document.addEventListener('DOMContentLoaded', () => {
    const iframePlayers = new Map();
    let isApiReady = false;

    window.onYouTubeIframeAPIReady = () => {
        isApiReady = true;
    };

    window.initializeModalAndVideo = (iframeElement) => {
        if (!isApiReady) {
            return;
        }

        const modal = iframeElement.closest('.modal');
        if (modal) {
            iframePlayers.set(iframeElement, new YT.Player(iframeElement));
        }
    };

    const observerCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const modal = mutation.target;
                const iframe = modal.querySelector('iframe[src*="youtube.com/embed"]');

                if (iframe) {
                    if (!modal.classList.contains('show') && !modal.classList.contains('in')) {
                        const player = iframePlayers.get(iframe);
                        if (player && typeof player.pauseVideo === 'function') {
                            player.pauseVideo();
                        }
                    }
                }
            }
        }
    };

    const observer = new MutationObserver(observerCallback);

    const config = {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
    };
    observer.observe(document.body, config);

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});
